// M26.1 — single source of truth for the 7 Project workspace tabs, shared by
// every page via ProjectWorkspaceLayout. Details/Channel Rules/Team only
// ever exist as internal tabs of ProjectForm (`to: null` there — the parent
// handles them via `@tab-click`); Documents/Inventory get a route too since
// they're also directly linkable. Knowledge/AI Employee are always routes.
//
// M29.5.21 — the project-level "Google Sync" tab (M29.5.20 Part 19) was
// removed. Google inventory sync configuration now lives entirely at
// Settings → Integrations → Google (NEXCEO), account-wide, instead of being
// configured per project. The underlying backend (ProjectGoogleSyncController,
// google_sheets_* columns on Nexceo::Project) is unchanged and still reused
// by that account-level page for per-project actions.
//
// M29.5.18 (Final Agent Workspace) — `agentOnly` collapses this down to just
// Documents/Inventory for a plain project_executive. Callers must default
// `agentOnly` to true until the caller positively knows the current user is
// an administrator or team leader (see ProjectDocuments.vue/
// ProjectInventory.vue) — defaulting the other way would flash the
// restricted tabs an agent must never see while role data is still loading.
const AGENT_VISIBLE_KEYS = ['documents', 'inventory'];

export function projectWorkspaceTabs({
  standalone,
  id,
  accountId,
  agentOnly = false,
}) {
  const routeTo = name => ({ name, params: { id, accountId } });

  const tabs = [
    {
      key: 'details',
      label: 'Project Details',
      icon: 'i-lucide-building-2',
      to: standalone ? routeTo('nexceo_projects_edit') : null,
    },
    {
      key: 'documents',
      label: 'Documents',
      icon: 'i-lucide-file-text',
      to: standalone ? routeTo('nexceo_project_documents') : null,
    },
    {
      key: 'inventory',
      label: 'Inventory',
      icon: 'i-lucide-layout-grid',
      to: standalone ? routeTo('nexceo_project_inventory') : null,
    },
    {
      key: 'source_rules',
      label: 'Channel Rules',
      icon: 'i-lucide-radio',
      to: standalone ? routeTo('nexceo_projects_edit') : null,
    },
    {
      key: 'team_members',
      label: 'Team',
      icon: 'i-lucide-users',
      to: standalone ? routeTo('nexceo_projects_edit') : null,
    },
    {
      key: 'knowledge',
      label: 'Knowledge',
      icon: 'i-lucide-brain',
      to: routeTo('nexceo_project_knowledge'),
    },
    {
      key: 'ai_employee',
      label: 'AI Employee',
      icon: 'i-lucide-bot',
      to: routeTo('nexceo_ai_employee_settings'),
    },
  ];

  return agentOnly
    ? tabs.filter(tab => AGENT_VISIBLE_KEYS.includes(tab.key))
    : tabs;
}
